import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/fgfgv-v.png';
import styles from './Footer.module.css';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerMain}>
        <div className={styles.container}>
          <div className={styles.footerGrid}>
            {/* Company Info */}
            <div className={styles.footerColumn}>
              <div className={styles.logoSection}>
                <img src={logo} alt="Al Nasr Forging" className={styles.footerLogo} />
                <p className={styles.companyDescription}>
                  {t('footer.description')}
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <div className={styles.footerColumn}>
              <h3 className={styles.footerTitle}>{t('footer.quickLinks')}</h3>
              <ul className={styles.footerLinks}>
                <li><Link to="/">{t('nav.home')}</Link></li>
                <li><Link to="/about">{t('nav.about')}</Link></li>
                <li><Link to="/products">{t('nav.products')}</Link></li>
                <li><Link to="/factory">{t('nav.factory')}</Link></li>
              </ul>
            </div>

            {/* More Links */}
            <div className={styles.footerColumn}>
              <h3 className={styles.footerTitle}>{t('footer.moreLinks')}</h3>
              <ul className={styles.footerLinks}>
                <li><Link to="/investor">{t('nav.investor')}</Link></li>
                <li><Link to="/partners">{t('nav.partners')}</Link></li>
                <li><Link to="/media">{t('nav.media')}</Link></li>
                <li><Link to="/contact">{t('nav.contact')}</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className={styles.footerColumn}>
              <h3 className={styles.footerTitle}>{t('footer.contact')}</h3>
              <ul className={styles.contactList}>
                <li>
                  <svg className={styles.icon} viewBox="0 0 20 20" fill="currentColor">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  <span>{t('contact.phone1')}</span>
                </li>
                <li>
                  <svg className={styles.icon} viewBox="0 0 20 20" fill="currentColor">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  <span>{t('contact.phone2')}</span>
                </li>
                <li>
                  <svg className={styles.icon} viewBox="0 0 20 20" fill="currentColor">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <span>{t('contact.email')}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className={styles.copyright}>
        <div className={styles.container}>
          <p className={styles.copyrightText}>
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

